import { BodyText } from "@/components/ui";
import { formatPhoneNumber } from "@/lib/formatters";
import { cn } from "@/lib/utils";
import {
  ORDERING_UNAVAILABLE_REASON_LABELS,
  type PSCLocation,
} from "../../network/useSearchLabPSCLocations";

export function PSCOption({
  psc,
  checked,
  onChange,
}: {
  psc: PSCLocation;
  checked: boolean;
  onChange(): void;
}) {
  const isUnavailable = Boolean(psc.orderingUnavailableReason);
  const unavailableLabel = psc.orderingUnavailableReason
    ? (ORDERING_UNAVAILABLE_REASON_LABELS[psc.orderingUnavailableReason] ??
      "Ordering is not available at this location.")
    : null;

  return (
    <label
      htmlFor={`psc-${psc.locationId}`}
      className={cn(
        "bg-secondary p-3 rounded-lg flex flex-row gap-2",
        isUnavailable && "cursor-not-allowed opacity-75",
      )}
    >
      <div>
        <input
          type="radio"
          id={`psc-${psc.locationId}`}
          name="psc"
          value={psc.locationId}
          className="peer hidden"
          onChange={onChange}
          checked={checked}
          disabled={isUnavailable}
        />
        <div className="h-4 w-4 flex justify-center items-center rounded-full border bg-white">
          <span
            className={cn(
              "w-2 h-2 rounded-full block",
              checked && "bg-button-primary",
            )}
          />
        </div>
      </div>
      <div className="flex flex-col">
        <BodyText
          size="sm"
          textColor={unavailableLabel ? "tertiary" : "success"}
          bold
        >
          {psc.name}
        </BodyText>

        {psc.address?.map((line) => (
          <BodyText key={line} size="sm">
            {line}
          </BodyText>
        ))}
        <BodyText size="sm">
          {psc.city}, {psc.state} {psc.zip}
        </BodyText>
        <BodyText size="sm">{formatPhoneNumber(psc.phone)}</BodyText>
        {unavailableLabel && (
          <BodyText size="sm" textColor="warning">
            {unavailableLabel}
          </BodyText>
        )}
      </div>
    </label>
  );
}
